const modalTrigger = (id, endpoint = '', trackingEvent = false, trackingCategory = null) => ({
  '@click.prevent.stop'() {
    this.$store.modal.open(id, endpoint, trackingEvent, trackingCategory);
  },
});

export default modalTrigger;
